import { IHaynesCustomer, IHaynesLicense } from '@cbgms/api'
import { Table } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const HaynesCustomerDataSummary = (p: {
  haynesCustomer: IHaynesCustomer
  licenses?: IHaynesLicense[]
  inactiveLicenses?: IHaynesLicense[]
}) => {
  const { t } = useTranslation()

  if (!p.haynesCustomer) return null
  return (
    <Table basic='very' celled collapsing>
      <Table.Body>
        <Table.Row>
          <Table.Cell>{t('haynespro.customer_id')}</Table.Cell>
          <Table.Cell>{p.haynesCustomer.CustomerID}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.client_id')}</Table.Cell>
          <Table.Cell>{p.haynesCustomer.ClientID}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.username')}</Table.Cell>
          <Table.Cell>{p.haynesCustomer.Username}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.password')}</Table.Cell>
          <Table.Cell>{p.haynesCustomer.Password}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.Product_type')}</Table.Cell>
          <Table.Cell>
            {p.haynesCustomer.ProductTypes?.map(l => (
              <span key={l.ID}>
                {l.ID}:{l.Name}
                <br />
              </span>
            ))}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.reseller')}</Table.Cell>
          <Table.Cell>{p.haynesCustomer.Reseller?.Name}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.licenses_for_customers')}</Table.Cell>
          <Table.Cell>
            {p.licenses?.map(l => (
              <span key={l.LicenseID}>
                {l.LicenseID}, {l.BeginDate}, {l.EndDate} ({l.ProductType.Name})
                <br />
              </span>
            ))}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('haynespro.inactive_licenses_for_customers')}</Table.Cell>
          <Table.Cell>
            {p.inactiveLicenses?.map(l => (
              <span key={l.LicenseID}>
                {l.LicenseID}, {l.BeginDate}, {l.EndDate} ({l.ProductType.Name})
                <br />
              </span>
            ))}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

export default HaynesCustomerDataSummary
